export const storageKeys = {
    identification: '@identification',
}